import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-895958d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "video-container",
    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.togglePlay && _ctx.togglePlay(...args))),
    onContextmenu: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"]))
  }, [
    _createElementVNode("video", {
      ref: "videoRef",
      controls: "",
      controlsList: "nodownload",
      onPlay: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logPlayEvent && _ctx.logPlayEvent(...args))),
      onPause: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logPauseEvent && _ctx.logPauseEvent(...args))),
      onEnded: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.logEndedEvent && _ctx.logEndedEvent(...args))),
      onTimeupdate: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.checkHalfWatched && _ctx.checkHalfWatched(...args))),
      onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("source", {
        src: _ctx.videoSrc,
        type: "video/mp4"
      }, null, 8, _hoisted_1),
      _createTextVNode(" Your browser does not support the video tag. ")
    ], 544),
    (!_ctx.isPlaying)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "play-button",
          onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.togglePlay && _ctx.togglePlay(...args)), ["stop"]))
        }))
      : _createCommentVNode("", true)
  ], 32))
}